import * as React from "react";
import { IConfigContext } from "./types";

const ConfigContext = React.createContext<IConfigContext | undefined>(undefined);
ConfigContext.displayName = "ConfigContext";

export default ConfigContext;
